<template>
  <section class="top_banner_info">
    <p class="country">{{ getGovernorateTranslation(userDetails.governorate) }}</p>
    <p class="name"> {{ userDetails.username }} </p>
  <div class="flex-row">
    <div class="bg_border points_no_click">
      <div class="flex-row">
        <p>{{ userDetails.totalPointsEarned }}</p>
        <img src="/static/images/home/points_star.png" class="points_img_anim">
      </div>
    </div>
    <div class="bg_border">
      <div class="flex-row" @click.prevent="goToStore">
        <p> {{ userDetails.availableGames }} </p>
        <img src="/static/images/book.png" class="book_img">
        <img src="/static/images/home/more_quizes_icon.svg" class="plus_btn">
      </div>
    </div>
  </div>

  <div class="lvl_bar_sect flex-column">
    <div class="lvl_bar_text flex-row">
      <div class="lvl_title flex-row" @click.prevent="showLevelModal">
        <img :src="getLevelBadge" class="lvl_icon" />
        <p><b>{{ getTranslations.home_profile_level }} {{ userDetails.level }} {{ getTranslations['home_profile_level_' + userDetails.level] }}</b></p>
      </div>
      <div class="lvl_points flex-row">
        <img src="/static/images/home/points_star.png" class="points_img">
        <p><b>{{ userDetails.remainingPointsToLevel }}</b> {{ getTranslations.home_profile_stats_left_level}}</p>
      </div>
    </div>

    <div class="flex-row progress">
      <div
        class="progress-container"
        v-for="(bar, index) in 10"
        :key="index"
        :data-progress="getSegmentFill(index)">
        <div class="progress-bar"
             :style="{ width: getSegmentFill(index) + '%'}">
        </div>
      </div>
    </div>


  </div>
  </section>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import {governorateTranslationMap} from "../../../constants/governorate";
import modals from '@/common/modals';
import LevelModal from "../modals/LevelModal";

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  components: {
    LevelModal
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),

    showLevelModal() {
      console.log("showLevelModal triggered");
      this.storeModalForHomePage(LevelModal);
      modals.showHideModal(this);
    },
    getGovernorateTranslation(governorateCode) {
      const translationKey = governorateTranslationMap[governorateCode];
      return this.getTranslations[translationKey] || governorateCode; // Fallback to the code if no translation found
    },
    formattedValue(intValue) {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        return intValue.toLocaleString();
      }
      return intValue;
    },
    getSegmentFill(index) {
      const progressPerSegment = 100 / 10;
      const filledPercentage = this.progressPercentage;

      if (filledPercentage >= (index + 1) * progressPerSegment) {
        return 100;
      }

      if (index === Math.floor(filledPercentage / progressPerSegment)) {
        return (filledPercentage % progressPerSegment) * 10;
      }

      return 0;
    },
    goToStore() {
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'availableIntegrations',
      'integrationHeader',
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    progressPercentage() {
      const totalPointsRequired = this.userDetails.totalPointsEarned + this.userDetails.remainingPointsToLevel;
      return Math.floor((this.userDetails.totalPointsEarned / totalPointsRequired) * 100);
    },
    getLevelBadge() {
      const level = Math.min(this.userDetails.level, 4); // Ensures level doesn't exceed 4
      return `/static/images/levels/badges/lvl${level}_icon.png`;
    },
  },
  ...mapState('game', [
    'playersDetails',
  ]),
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue